import { render, staticRenderFns } from "./featureManagement.vue?vue&type=template&id=02d2563b&scoped=true"
import script from "./featureManagement.vue?vue&type=script&lang=js"
export * from "./featureManagement.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./featureManagement.vue?vue&type=style&index=1&id=02d2563b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d2563b",
  null
  
)

export default component.exports